import { render, staticRenderFns } from "./bet-history.vue?vue&type=template&id=abcf3b46&scoped=true"
import script from "./bet-history.vue?vue&type=script&lang=js"
export * from "./bet-history.vue?vue&type=script&lang=js"
import style0 from "./bet-history.vue?vue&type=style&index=0&id=abcf3b46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcf3b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abcf3b46')) {
      api.createRecord('abcf3b46', component.options)
    } else {
      api.reload('abcf3b46', component.options)
    }
    module.hot.accept("./bet-history.vue?vue&type=template&id=abcf3b46&scoped=true", function () {
      api.rerender('abcf3b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/bet-history.vue"
export default component.exports